import { api } from "@/lib/api";
import { toast } from "sonner";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Download a PDF from an authenticated endpoint. Triggers browser save dialog.
 * If `open=true` opens in new tab instead of downloading.
 */
export async function downloadPdf(path, filename, { open = false } = {}) {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    if (open) {
      window.open(url, "_blank", "noopener");
    } else {
      const a = document.createElement("a");
      a.href = url; a.download = filename;
      document.body.appendChild(a); a.click(); a.remove();
    }
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (e) {
    toast.error("Failed to generate PDF");
    throw e;
  }
}

export function downloadInvoice(sale) {
  return downloadPdf(`/sales/${sale.id}/invoice.pdf`, `${sale.invoice_no}.pdf`);
}
export function previewInvoice(sale) {
  return downloadPdf(`/sales/${sale.id}/invoice.pdf`, "", { open: true });
}
export function downloadStatement(client) {
  const safe = client.name.replace(/[^a-z0-9]+/gi, "_").slice(0, 40);
  return downloadPdf(`/clients/${client.id}/statement.pdf`, `Statement_${safe}.pdf`);
}
export function previewStatement(client) {
  return downloadPdf(`/clients/${client.id}/statement.pdf`, "", { open: true });
}

export function downloadSupplierStatement(supplier) {
  const safe = supplier.name.replace(/[^a-z0-9]+/gi, "_").slice(0, 40);
  return downloadPdf(`/suppliers/${supplier.id}/statement.pdf`, `Statement_${safe}.pdf`);
}

export function downloadPurchaseInvoice(purchase) {
  const name = (purchase.invoice_no || `purchase-${purchase.id?.slice(0, 8)}`).replace(/[^a-z0-9]+/gi, "_");
  return downloadPdf(`/purchases/${purchase.id}/invoice.pdf`, `${name}.pdf`);
}

// One grouped invoice per supplier + date (all that day's purchases from that supplier).
export function downloadPurchaseGroupInvoice(group) {
  const qs = new URLSearchParams({ supplier_id: group.supplier_id, date: group.date }).toString();
  const safe = (group.supplier_name || "supplier").replace(/[^a-z0-9]+/gi, "_");
  return downloadPdf(`/purchases/invoice.pdf?${qs}`, `purchase-${safe}-${group.date}.pdf`);
}

export function downloadPurchaseOrder(po) {
  const name = (po.po_no || `PO-${po.id?.slice(0, 8)}`).replace(/[^a-z0-9]+/gi, "_");
  return downloadPdf(`/purchase-orders/${po.id}/po.pdf`, `${name}.pdf`);
}

export function downloadProducts(filters = {}) {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v != null && v !== "" && v !== "all") p.set(k, v); });
  const qs = p.toString();
  return downloadPdf(`/products/export.pdf${qs ? "?" + qs : ""}`, "inventory.pdf");
}

// also export base for non-axios needs
export { BASE };
